import * as React from 'react';
import { DateLocale } from './date.locale';
const dateFormat = require('dateformat');

export interface DateProps {
  value: Date;
  locale: DateLocale;
}

const Date: React.SFC<DateProps> = ({ value, locale }) => {
  dateFormat.i18n = { ...dateFormat.i18n, ...locale.dateFormat };

  return <>{dateFormat(value, locale.format)}</>;
};

export default Date;



// WEBPACK FOOTER //
// /www/client/src/components/Date/Date.tsx